









import { Component, Prop, Vue } from 'vue-property-decorator';

export default {
  name: "FColorSettings",
  data(){
      return {
          framenames: ['Padding', 'Rst_Stream', 'Connection_Close', 'Application_Close', 'Max_Data', 'Max_Stream_Data', 'Max_Stream_Id', 'Ping', 'Blocked', 'Stream_Blocked',
            'Stream_Id_Blocked', 'New_Connection_Id', 'Stop_Sending', 'Ack', 'Path_Challenge', 'Path_Response', 'Stream']
      }
  },
  computed:{ 
    framecolors() {
      return this.$store.state.framecolortables.getAllFrameColours()
  }},
  methods: {
      getName(index: number){
          return this.framenames[index]
      }
  }
}
